import React, {useState, useEffect} from "react";
import {
  FormControl,
  Button,
  Input,
  InputRightElement,
  InputGroup,
  Flex,
} from "@chakra-ui/react";
import MultiSelect from "react-multi-select-component";

import { IconTriangle, IconLocation } from "@assets/Icons";
import { t } from "@lang/i18n";
import { dataList } from "@lib/datahandlers/global";

// Import React Script Libraray to load Google object
import Script from 'react-load-script';
import { getPredictions } from '@lib/autocomplete';
import { google_api_key } from "@config";


const multiselect_strings = {
  allItemsAreSelected: t('multiselect.allItemsAreSelected'),
  clearSearch: t('multiselect.clearSearch'),
  noOptions: t('multiselect.noOptions'),
  search: t('multiselect.search'),
  selectAll: t('multiselect.selectAll'),
  selectSomeItems: t('multiselect.selectSomeItems'),
};

const SearchForm = ({
  setForm,
  form,
  page,
  onSearch
}) => {
  const initStateDataList = {
    fonctions: [],
    contracts: [],
    experiences: [],
  };
  const [selectData, setSelectData] = useState(initStateDataList);

  // render arrow / value of multi select
  const arrowRender = () => (<IconTriangle iconType="company" position="down" />)
  // filter  multi select
  const filterOptions = (options, value) => {
    if (!value) return options;
    
    const normalized_value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const result = options.filter((el, idx) => {
      const normalized_item = el.label.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
      if (normalized_item.includes(normalized_value)) return el
    });

    return result
  };

  // load data list
  const getDataList = async () => {
    const data = await dataList();

    setSelectData({
      ...selectData,
      fonctions: data.fonctions.map(el => ({ value: el.id, label: el.name })),
      contracts: data.contracts.map(el => ({ value: el.id, label: el.name })),
      experiences: data.experience_intervals.map(el => ({ value: el.id, label: el.name })),
    });
  };

  /* load data list */
  useEffect(() => {
    getDataList()
  }, []);
  
  const onPlaceSelected = (params) => {
    setForm(prevState => {
      return { ...prevState, ...params }
    });
  };
  const onAddressChange = (text) => {
    if(!text) setForm(prevState => {
                return { ...prevState, address: text, longitude: "", latitude: "", region: "", department: "", city: ""}
              })
    else setForm(prevState => {
            return { ...prevState, address: text }
          })
  };

  return (
    <Flex flexDir="row" justifyContent={{base: "space-around", lg: "space-between"}} flexWrap="wrap" mb="2.06rem">
      <FormControl id="fonctions" isRequired mb="1.625rem" w={["90vw", "20rem"]}>
          <MultiSelect
              options={selectData.fonctions}
              value={form.fonctions}
              onChange={(value) => setForm({ ...form, fonctions: value })}
              ArrowRenderer={arrowRender}
              filterOptions={filterOptions}
              valueRenderer={(val) => (!val.length? t('fields.candidates.metier') : null)}
              className={("className", "multi-select company search")}
              labelledBy={"fonctions"}
              overrideStrings={multiselect_strings}
          />
      </FormControl>

      <Script url={`https://maps.googleapis.com/maps/api/js?key=${google_api_key}&libraries=places`}
        onLoad={() => getPredictions({ inputId:'autocomplete', callback: onPlaceSelected })}
      />
      <FormControl id="address" isRequired mb="1.625rem" w={["90vw", "20rem"]} pos="relative">
        <InputGroup>
          <Input
            type="text"
            name="address"
            placeholder="Ville, département, région..."
            _placeholder={{color:'#AAA'}}
            borderColor="gray.borders"
            borderRadius="3px"
            bg="white"
            maxW="20rem"
            h="38px"
            focusBorderColor="green.light"
            autoComplete="off"
            value={form.address}
            onChange={e => onAddressChange(e.target.value)}
            id="autocomplete"
          />

          <InputRightElement
            children={<IconLocation iconType="company" />}
            top="-2px"
          />
        </InputGroup>
      </FormControl>

        <FormControl id="contracts" isRequired mb="1.625rem" w={["90vw", "20rem"]}>
            <MultiSelect
                options={selectData.contracts}
                value={form.contracts}
                onChange={(value) => setForm({ ...form, contracts: value })}
                ArrowRenderer={arrowRender}
                valueRenderer={val => !val.length? t('fields.company.contracts') : null}
                className={("className", "multi-select company search")}
                labelledBy={"contracts"}
                overrideStrings={multiselect_strings}
            />
        </FormControl>

        <FormControl id="experiences" isRequired mb="1.625rem" w={["90vw", "20rem"]}>
            <MultiSelect
                options={selectData.experiences}
                value={form.experiences}
                onChange={(value) => setForm({ ...form, experiences: value })}
                ArrowRenderer={arrowRender}
                valueRenderer={val => !val.length? t('fields.company.experience') : null}
                className={("className", "multi-select company search")}
                labelledBy={"experiences"}
                overrideStrings={multiselect_strings}
            />
        </FormControl>

      <Button type="submit" bg="green.main" borderRadius="1.5rem" border="2px solid" borderColor="green.main" color="white" w="15.93rem" h="40px"
        _hover={{ bg: "green.light", borderColor: "green.light" }} onClick={() => onSearch(page)}>
          { t('company.search_candidates.search') }
      </Button>
    </Flex>
  );
};

export default SearchForm;
